export enum SMTPSource {
    ERRORRED = 98,
    NONE = 99,
    SMTP = 0,
    OFFICE365 = 1,
    GMAIL = 2,
    AWS_SES = 3
}
export enum IMAPSource {
    ERRORRED = 98,
    NONE = 99,
    IMAP = 0,
    OFFICE365 = 1,
    GMAIL = 2
}
export interface EmailServiceOptions {
    id?: number;
    tenant_id?: number;

    // General
    workingEmailAlias: string;
    workingEmail: string;
    workingEmailPassword: string | null;
    workingEmailSignaturePlain: string;
    workingEmailSignatureHtml: string;
    // AWS SES
    awsSesAccessKeyId: string;
    awsSesAccessKeySecret: string | null;
    awsSesLimitPerSecond: number;
    // SMTP
    smtpHost: string;
    smtpPort: number;
    smtpSecure: boolean;
    // IMAP
    imapHost: string;
    imapPort: number;
    imapUsername: string;
    imapPassword: string | null;
    // Office 365 & Gmail
    emailAccessToken: string | null;
    emailRefreshToken: string | null;
    emailTokenExpiresOn: Date;

    // Which one is active
    smtpSource: SMTPSource;
    imapSource: IMAPSource;
    imapErrorCount: number;

    // Settings
    runAIFindMatching: boolean;
}

export interface IncomingEmail {
    matchingNegotiationId?: string;
    plainPart: string;
    inlineImages: Buffer<ArrayBuffer>[];
    attachedPdfs: Buffer<ArrayBuffer>[];
    attachedXlsx: Buffer<ArrayBuffer>[];
    attachedCsv: Buffer<ArrayBuffer>[];
    inReplyTo: string;
    reference: string;
    messageId: string;
    messageSubject: string;
    from: string;
    uid: number | string;
}

export interface SerializedIncomingEmail extends Omit<IncomingEmail, 'inlineImages' | 'attachedPdfs' | 'attachedXlsx' | 'attachedCsv'> {
    inlineImages: string[];
    attachedPdfs: string[];
    attachedXlsx: string[];
    attachedCsv: string[];
}